// extracted by mini-css-extract-plugin
export default {"title":"styles_title__eXi2T","subTitle":"styles_subTitle__7OB8t","text":"styles_text__mZUVb"};